import axios from '@/axios';

/**
 * 광고 병원 관리 API (inapi admin/featured-hospitals, 운영자 전용)
 */
const HospitalAdApi = {
  /**
   * 광고 병원 목록 조회
   * @returns {Promise} [{ companyId, name, region, isFeatured, startDate, endDate, registeredAt }]
   */
  getList() {
    return axios.get('/admin/featured-hospitals');
  },

  /**
   * 광고 병원 추가
   * @param {Object} data
   * @param {string} data.companyId - 병원 ID
   * @param {string} data.startDate - 'YYYY-MM-DD'
   * @param {string|null} data.endDate - 'YYYY-MM-DD', 마감일 없음이면 null
   * @param {boolean} data.isFeatured - 게시 여부
   * @returns {Promise}
   */
  create(data) {
    return axios.post('/admin/featured-hospitals', data);
  },

  /**
   * 광고 기간·게시 여부 수정 (세 값을 모두 보낸다)
   * @param {string} companyId - 병원 ID
   * @param {Object} data - { startDate, endDate, isFeatured }
   * @returns {Promise}
   */
  update(companyId, data) {
    return axios.patch(`/admin/featured-hospitals/${companyId}`, data);
  },

  /**
   * 광고 병원 삭제 (광고 값 비움)
   * @param {string} companyId - 병원 ID
   * @returns {Promise}
   */
  remove(companyId) {
    return axios.delete(`/admin/featured-hospitals/${companyId}`);
  },
};

export default HospitalAdApi;
